import SimpleBar from 'simplebar';
import dataLayerEvents from  '../includes/dataLayerEvents';


export default {
  init() {
    // JavaScript to be fired on all pages

    /* eslint-disable */
    $('#generate-pdf-button').on('click', function() {

      var element = document.getElementById('main-post-content');

      let content_height = element.clientHeight / 96;

      var url = window.location.href;
      var url_array = url.split('/');
      let slug = url_array[url_array.length-2];

      const options = {
        margin: 0.3,
        filename: slug,
        pagebreak: {
          mode: 'avoid-all',
        },
        image: { 
          type: 'jpeg', 
          quality: 0.8 
        },
        html2canvas: { 
          scale: 1,
          windowWidth: 1440, 
          imageTimeout: 30000, // Ensure images are fully loaded
        },
        jsPDF: { 
          unit: 'in', 
          format: [15, content_height+1], 
          orientation: 'portrait',
          hotfixes: ['px_scaling'],
          precision: 2,
        }
      }

      html2pdf().from(element).set(options).toContainer().save();
      
    })
    /* eslint-enable */



    


    dataLayerEvents.init();

    var Header = {};

    Header.Scroll = function () {
      $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        if (scroll >= 50) {
          $('header.banner').addClass('scrolled');
        }
        else {
          $('header.banner').removeClass('scrolled');
        }
      });
    }

    Header.Scroll();

    if ( $('.block-anchor-nav').length ) {
      let hasScrolled = false;
      $(window).on('scroll', function () {
        if (!hasScrolled && $(window).scrollTop() >= 50) {
          $('body').scrollspy({
            target: '.block-anchor-nav-wrapper',
            offset: $('.banner.scrolled .header-inner').outerHeight(true) + 57,
          })
          hasScrolled = true;
        }
      })

    }

    $( '.maparea' ).each( function () {
      var tooltipArea = $( this );
      this.addEventListener( 'mousemove', function(MouseEvent) {
          if ( tooltipArea ) {
              $('.tooltip').css({
                  'transform': 'none',
                  'top': MouseEvent.pageY + 'px',
                  'left': MouseEvent.pageX + 'px',
                  'display': 'block',
              });
          }
      } )
    } )

    $( '.block-interactive-map [data-bs-toggle="tooltip"]' ).tooltip();

    $( document ).bind( 'scroll', function () {
      if ( $( '.tooltip' ).is( ':visible' ) ) {
        $( '.tooltip' ).hide();
      }
    } )

    $('.overflowing-slider .slider').each(function() {
      $(this).slick({
        dots: false,
        arrows: true,
        slidesToShow: $(this).data('slides'),
        slidesToScroll: 1,
        infinite: false,
        rows: 0,
        prevArrow: $(this).parents('.overflowing-slider').find('.nav-arrows .slick-prev'),
        nextArrow: $(this).parents('.overflowing-slider').find('.nav-arrows .slick-next'),
        centerMode: false,
        mobileFirst: false,
        responsive: [
            {
                breakpoint: 991,
                settings: 'unslick',
            },
        ],
      });
    })

    function initialize_slider() {
      let breakpoint = 991;

      let slider = $('.overflowing-slider .slider');

      function initialize_slick() {
        slider.each(function() {
          if (!$(this).hasClass('slick-initialized')) {
            $(this).slick({
              dots: false,
              arrows: true,
              slidesToShow: $(this).data('slides'),
              slidesToScroll: 1,
              infinite: false,
              rows: 0,
              prevArrow: $(this).parents('.overflowing-slider').find('.nav-arrows .slick-prev'),
              nextArrow: $(this).parents('.overflowing-slider').find('.nav-arrows .slick-next'),
              centerMode: false,
              mobileFirst: false,
            });
          }
        });
      }

      function unslick() {
        slider.each(function() {
          if (!$(this).hasClass('slick-initialized')) {
            $(this).slick('unslick');
          }
        })
      }

      if ($(window).width() > breakpoint) {
        initialize_slick();
      }

      $(window).on('resize', function() {
        if ($(window).width() > breakpoint) {
          initialize_slick();
        } else {
          unslick();
        }
      });

    }

    initialize_slider();
    
    if ($(window).width() < 991) {
      // if ($('.block-gallery .slider-container').length) {
      //   new SimpleBar($('.block-gallery .slider-container')[0], {
      //     autoHide: false,
      //   });
      // }
      $('.overflowing-slider .slider-container').each(function() {
        new SimpleBar(this, {
          autoHide: false,
        });
      })
    }

    // $('.save-as-pdf').on('click', function() {
    //   // (async () => {

    //   // })();
    //   // (async function() {
    //     const browser = puppeteer.launch();
    //     const page = browser.newPage();
    //     page.goto(window.location.href, { waitUntil: 'networkidle2' });
    //      page.pdf({ path: 'output.pdf', format: 'A4' });
    //      browser.close();
    //   // })();


    //   // download();

    // });

  },
  finalize() {

    function smooth_scroll_to_div() {

      $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .not('.nav-item')

      .click(function (event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
          &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();

            // const breakpoint = window.matchMedia('(min-width: 1400px)');

            // let negate_space;

            // if (breakpoint.matches === true) {

            //   if (!$('header.banner').hasClass('scrolled')) {
            //     $('header.banner').addClass('scrolled');
            //     negate_space = $('header.banner.scrolled').outerHeight(true) + 57;
            //   }
            // }
            // else {
            //   negate_space = $('.banner .header-inner').outerHeight(true) + 57;
            // }
            setTimeout(() => {
              $('html, body').animate({
                scrollTop: target.offset().top - ($('.banner .header-inner').outerHeight(true) + 57),
              }, 500, 'linear', function () {

              });
            }, 100);
          }
        }
      });
    }

    smooth_scroll_to_div();

    $(document).on('click', '.site-selector-toggler, .toggle-site-selector', function () {
      $('.site-selector-toggler').addClass('show');
      $('#site-dropdown').addClass('show');
    });

    $(document).on('click', '#site-dropdown .btn-close', function () {
      $('.site-selector-toggler').removeClass('show');
      $('#site-dropdown').removeClass('show');
    });




    $('.hamburger').click(function () {
      $(this).toggleClass('is-active');
      // $('header.banner').toggleClass('expanded');

      // Close all sub dropdown on mobile
      if (isMobileNavActive()) {
        $('.main-nav-dropdown .hover-dropdown-menu.show').removeClass('show');
        $('.main-nav-dropdown .hover-dropdown-toggle.show').removeClass('show');

        $('#menu-main .dropdown-toggle.show').removeClass('show');
        $('#menu-main .dropdown-mega-menu.show').removeClass('show');
      }
    });

    $(document).on('click', '.dropdown-menu .btn-close', function () {
      $(this).parents('.dropdown-wrap').find('.dropdown-toggle').dropdown('toggle');
    });

    // Back button main nav mobile
    $(document).on('click', '.main-nav-dropdown .back-button', function () {

      var parentItem = $(this).parents('.nav-item').first();
      if ($(this).parents('.sub-menu-level-1').length) {
        parentItem.find('.hover-dropdown-toggle').removeClass('show');
        parentItem.find('.hover-dropdown-menu').removeClass('show');
      }
      else {
        $(this).parents('.nav-item').first().find('>.dropdown-toggle.show').dropdown('toggle');
      }

      setTimeout(() => {
        $('header.banner').removeClass('second-level-open');
      }, 100);
      

    });

    // Close Btn on main nav dropdown
    $(document).on('click', '.main-nav-dropdown .btn-close', function () {
      $(this).parents('.nav-item').find('>.dropdown-toggle.show').dropdown('toggle');
    });

    // Hover on Main nav sub menu (desktop only)
    $(document).on('mouseover touch', '.main-nav-dropdown .sub-menu-level-1 >.nav-item >.nav-link', function () {
      if (!isMobileNavActive()) {
        $('.main-nav-dropdown .hover-dropdown-menu.show').removeClass('show');
        $('.main-nav-dropdown .hover-dropdown-toggle.show').removeClass('show');
        $(this).parent('.nav-item').find('.hover-dropdown-menu').addClass('show');
        $(this).addClass('show');
        calculateMainMenuHeight();
      }
    });

    // Hover on Main Nav level 0
    $(document).on('mouseenter', '#menu-main >.nav-item >.nav-link', function () {

      if (!isMobileNavActive()) {
        $('.main-nav-dropdown .hover-dropdown-menu.show').removeClass('show');
        $('.main-nav-dropdown .hover-dropdown-toggle.show').removeClass('show');

        $('#menu-main .dropdown-toggle.show').removeClass('show');
        $('#menu-main .dropdown-mega-menu.show').removeClass('show');

        if ($(this).hasClass('dropdown-toggle')) {
          $(this).parent('.nav-item').find('.hover-dropdown-toggle').first().addClass('show');
          $(this).parent('.nav-item').find('.hover-dropdown-menu').first().addClass('show');
          calculateMainMenuHeight();
          $(this).addClass('show');
          $(this).parent('.nav-item').find('.dropdown-mega-menu').addClass('show');
          $(this).siblings('.main-nav-dropdown').find('.bg').css('min-height', $(this).siblings('.main-nav-dropdown').find('.navbar-nav').height() + (54 + 16));
        }
      }
    });

    // Main nav close dropdown on mouse leave
    $(document).on('mouseleave', '#menu-main >.nav-item', function () {
      if (!isMobileNavActive()) {
        $('#menu-main .dropdown-toggle.show').removeClass('show');
        $('#menu-main .dropdown-mega-menu.show').removeClass('show');
      }
    });

    // Main nav sublevel 1 - click on mobile 
    $(document).on('click', '#menu-main .sub-menu-level-1 >.nav-item >.nav-link.hover-dropdown-toggle', function (e) {
      if (isMobileNavActive()) {
        e.preventDefault();
        $('.main-nav-dropdown .hover-dropdown-menu.show').removeClass('show');
        $('.main-nav-dropdown .hover-dropdown-toggle.show').removeClass('show');
        $(this).parent('.nav-item').find('.hover-dropdown-menu').addClass('show');
        $(this).addClass('show');
      }
    });

    // Collapse
    $('header.banner .navbar-collapse').on('hidden.bs.collapse', function() {
      // console.log('closed');
      $('header.banner').removeClass('expanded');
      $('.header.banner').removeClass('second-level-open');
      // if (isMobileNavActive()) {

      // }
    })
    .on('show.bs.collapse', function() {
      $('header.banner').addClass('expanded');
    })

    // Detect second level submenu opening
    $(document).on('click', '#menu-main > .menu-item.menu-item-has-children', function () {
      if ( isMobileNavActive() ) {
        $('header.banner').addClass('second-level-open')
      }
    })

    // Detect third level submenu opening
    $(document).on('click', '.sub-menu-level-1 .menu-item .nav-link.hover-dropdown-toggle', function () {
      if ( isMobileNavActive() ) {
        setTimeout(() => {
          $('header.banner').removeClass('second-level-open')
        }, 100);
      }
    })

    // Detect third level submenu closing (closing back button of third level)
    $(document).on('click', '.sub-menu-level-1 .back-button', function () {
      if ( isMobileNavActive() ) {
        setTimeout(() => {
          $('header.banner').addClass('second-level-open')
        }, 100);
      }
    })

    function isMobileNavActive() {
      var mobileNavBreakpoint = 992;
      if ($(window).width() < mobileNavBreakpoint) {
        return true;
      }
      return false;
    }

    function calculateMainMenuHeight() {
      var openedSubmenuDropdown = $('#menu-main .hover-dropdown-menu.show .sub-menu-wrap');
      var submenuHeight = 0;
      if (openedSubmenuDropdown.length) {
        submenuHeight = openedSubmenuDropdown.first().height();
      }
      $('#menu-main .main-nav-dropdown .navbar-nav').css('min-height', submenuHeight);
    }


    $(document).on('click', '.btn-add-download-cart', function (e) {
      e.preventDefault();

      var cartToast = $('#cartToast');
      var form = $('#add-to-cart-form');
      var data = form.serializeArray();
      data.push({
        name: 'document',
        value: $(this).data('document'),
      });

      $.ajax({
        data: data,
        method: 'POST',
        url: form.attr('action'),
        beforeSend: function () {
          //spinner.show();
        },
        success: function (response) {
          if (response.type == 'success') {
            $('.cart-toggle .counter').html(response.count);
            $('#cart-results').html(response.response);

            cartToast.find('.message').html(response.message);

            var toast = new bootstrap.Toast(cartToast);
            toast.show();
            
          } else {
            //window.location.replace(url);
          }
        },
        error: function () {
          //window.location.replace(url);
        },
        complete: function () {
          //spinner.hide();
        },
      });
    });

    $(document).on('click', '.btn-basket, .cart-toggle', function () {
      $('.cart-toggle').addClass('show');
      $('.cart-dropdown').addClass('show');
    });

    $(document).on('click', '.cart-dropdown .btn-close', function () {
      $('.cart-toggle').removeClass('show');
      $('.cart-dropdown').removeClass('show');
    });


    $(document).on('click', '.cart-item .cart-button.delete', function (e) {
      e.preventDefault();

      var form = $('#delete-from-cart-form');
      var data = form.serializeArray();
      data.push({
        name: 'document',
        value: $(this).data('document'),
      });

      $.ajax({
        data: data,
        method: 'POST',
        url: form.attr('action'),
        beforeSend: function () {
          //spinner.show();
        },
        success: function (response) {
          if (response.type == 'success') {
            $('.cart-toggle .counter').html(response.count);
            $('#cart-results').html(response.response);

          } else {
            //window.location.replace(url);
          }
        },
        error: function () {
          //window.location.replace(url);
        },
        complete: function () {
          //spinner.hide();
        },
      });
    });

  },
};




// WEBPACK FOOTER //
// ./scripts/routes/common.js